import { REQUEST_START, REQUEST_END } from '../action-types/api';

const initialState = {
  isLoading: false,
};

const apiReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_START:
      return {
        ...state,
        isLoading: true,
      };
    case REQUEST_END:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default apiReducer;
